import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";

interface IParams {
  municipality: string;
  street: string | undefined | null;
  streetNumber: string;
  apartmentNumber: string;
  streetId: number | undefined | null;
  municipalityId: number;
}

export async function addClientAddress({
  municipality,
  street,
  streetNumber,
  apartmentNumber,
  streetId,
  municipalityId,
}: IParams) {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/users/addresses`,
    {
      method: "patch",
      json: {
        type: "RESIDENTIAL",
        geographicalAddress: {
          municipality,
          street,
          streetNumber,
          apartmentNumber,
        },
        CBSReference: {
          streetId,
          municipalityId,
        },
      },
      headers: {
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
